export const prefix = {
  sys: '',
  iam: '',
  storage: '',
  flow: '',
  base: '',
  tpl: ''
};
export function initPrefix(config) {
  Object.assign(prefix, config?.app?.server?.modules_prefix || {});
  return prefix;
}